module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "coming-soon-modal"
  }, [_c('v-card-title', [_c('h2', {
    staticClass: "font card-title"
  }, [_vm._v("¡Importante!")])]), _vm._v(" "), (this.step === 1) ? _c('v-card-text', {
    staticClass: "font card-text"
  }, [_vm._v("\n      Vas a eliminar " + _vm._s(this.organization.name) + " y toda su información."), _c('br'), _vm._v("¿Deseas continuar?\n    ")]) : _c('v-card-text', {
    staticClass: "font card-text"
  }, [_vm._v("\n      Eliminar " + _vm._s(this.organization.name) + " y toda su información.\n    ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onCancel()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (this.step === 1) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onContinue()
      }
    }
  }, [_vm._v("Continuar")]) : _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onContinue()
      }
    }
  }, [_vm._v("Eliminar")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a628030","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/RemoveOrganizationModal.vue
// module id = 781
// module chunks = 5